import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sale from "./sale/Sale";
import { AlertProvider } from "./context/AlertContext";

function App() {
  return (
    <Router>
      <AlertProvider>
        <Main />
      </AlertProvider>
    </Router>
  );
}

function Main() {
  return (
    <Routes>
      <Route path="/share/sale" element={<Sale />} />
    </Routes>
  );
}

export default App;
